import * as React from 'react';
import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import Chip from '@mui/material/Chip';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { connect, useDispatch } from "react-redux";
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';

const MultipleSelectChip = ({ onChange, isDarkmode, ...props }) => {
  console.log(props);
  const darkTheme = createTheme({
    palette: {
      mode: (isDarkmode ? 'dark' : "light"),
    },
    components: {
      MuiOutlinedInput : {
        styleOverrides: {
          root: {
            padding: "10px",
            borderRadius: 15,
          },
          input: {
            padding: "0px !important",
            borderRadius: 0,
          },
        },
      },
    }
  });

  const handleChange = (event, value) => {
    onChange && onChange(value); 
  };

  return (
    <ThemeProvider theme={darkTheme}>
      <CssBaseline />
      <div>
        <FormControl className='w-full'>
          {props.singleSelect ? (
            <Autocomplete
              disablePortal
              options={props.options}
              value={props.value} 
              onChange={handleChange}
              renderInput={(params) => <TextField className='hide-input' {...params} />}
            />
          ) : (
            <Autocomplete
              multiple
              options={props.options}
              value={props.value}
              // filterSelectedOptions
              onChange={handleChange}
              renderTags={(value, getTagProps) =>
                value.map((option, index) => {
                  const { key, ...tagProps } = getTagProps({ index });
                  return (
                    <Chip size='small' label={option.label} key={option.value} {...tagProps} />
                  );
                })
              }
              isOptionEqualToValue={(option, value) => option.value === value.value}
              renderInput={(params) => (
                <TextField
                  className='hide-input'
                  {...params}
                />
              )}            
            />
          )}
        </FormControl>
      </div>
    </ThemeProvider>
  );
}

const mapStateToProps = (state) => ({
  isDarkmode: state.theme.darkmode.payload,
});

export default connect(mapStateToProps, { })(
  MultipleSelectChip
);
